// extracted by mini-css-extract-plugin
export default {"paymentSection":"X2-z","disabled":"Y2-z"};